module.exports = __webpack_public_path__ + "img/043.d6f60cf9.jpg";